import template from './has-phone.jade';

export default angular.module('cian.addForm.hasPhone', []).directive('cianAfAboutObjectHasPhone', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.items = [
      {
        text: 'Есть',
        value: true,
      },
      {
        text: 'Нет',
        value: false,
      },
    ];
  },
  controllerAs: 'hasPhone',
  template,
})).name;
